import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M8.25 4.5a.75.75 0 0 0-1.5 0v13.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72zM15.97 3.97a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V19.5a.75.75 0 0 1-1.5 0V6.31l-1.72 1.72a.75.75 0 1 1-1.06-1.06z" />
  </>
);

const Sort = Icon('sort', svgContents);

export default Sort;
